var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shouldShowAds && _vm.isScreenSizeOk
    ? _c(
        "div",
        {
          class: [
            _vm.paddingClass,
            _vm.backgroundClass,
            _vm.internalWrapperClass,
            _vm.adPosition,
            "rin-ad-wrapper",
          ],
        },
        [
          _vm.isGoogleAdsEnabled
            ? _c(
                "div",
                { staticClass: "rin-ad-slot" },
                [
                  _c("HideAdsBtn", { staticClass: "hide-ads" }),
                  _vm._v(" "),
                  _c("p", { staticClass: "advertisement-info" }, [
                    _vm._v(" " + _vm._s(_vm.translations["shared_Ads_Label"])),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      key: _vm.refreshKey,
                      class: { "ad-border": _vm.isLocal },
                      style: { maxWidth: _vm.adWidth, maxHeight: _vm.adHeight },
                    },
                    [
                      _c("Adsense", {
                        staticClass: "adsbygoogle",
                        attrs: {
                          "data-ad-client": "ca-pub-2431348456451065",
                          "data-ad-slot": _vm.dataAdSlot,
                          "ins-style": _vm.insstyle,
                          "data-ad-format": _vm.dataAdFormat,
                          "data-full-width-responsive":
                            _vm.dataFullWidthResponsive,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }